import { createSelector } from "reselect";
import { partnerNameSelector } from "../../../config_selectors";

export const nonWoundPdfDownloadEnabledSelector = createSelector(
  partnerNameSelector,
  partnerName => partnerName != "pcc" && partnerName != "pcc_wound"
);
